<template>
    <basic-container> 
      <div class="Impact-content">
        <!-- banner -->
			<div class="banner_w3lspvt-2">
				<ol class="breadcrumb">
					<li class="breadcrumb-item" aria-current="page">{{$t('ifm.title')}}</li>
				</ol>
			</div>
          <!-- //main banner -->
		<!-- stats -->
		<div class="container py-xl-5 py-lg-3">
			<p style="margin-bottom: 20px;">
				{{ $t('ifm.subTitle') }}</p>
			<h4 style="margin-bottom: 20px;">{{ $t('ifm.subTitle1') }}</h4>
			<p>{{ $t('ifm.subTitle4') }}</p>
		</div>
		<section class="bottom-count py-5" id="stats">
			<div class="container py-xl-5 py-lg-3">
				<div class="row">
					<div class="col-lg-5 left-img-w3ls">
						<img src="@/assets/images/b5.png" alt="" class="img-fluid">
					</div>
					<div class="col-lg-7 right-img-w3ls pl-lg-4 mt-lg-2 mt-4">
						<div class="bott-w3ls mr-xl-5">
							<h3 class="title-w3 text-bl mb-3 font-weight-bold">{{ $t('ifm.contentTitle1') }}</h3>
							<ul class="w3l-right-book mt-4">
								<li>{{ $t('ifm.contentFirstLi1') }}</li>
								<li>{{ $t('ifm.contentFirstLi2') }}</li>
							</ul>
                            <div
                  class="btn button-style mt-md-5 mt-4"
                  id="applyUse"
                  @click="openDialog"
                >
                  {{ $t("jem.application") }}</div>

						</div>

					</div>
				</div>
			</div>
		</section>
		<section class="bottom-count py-5" id="stats">
			<div class="container py-xl-5 py-lg-3">
				<div class="row">

					<div class="col-lg-7 right-img-w3ls pl-lg-4 mt-lg-2 mt-4">
						<div class="bott-w3ls mr-xl-5">
							<h3 class="title-w3 text-bl mb-3 font-weight-bold">{{ $t('ifm.contentTitle2') }}</h3>
							<ul class="w3l-right-book mt-4">
								<li>{{ $t('ifm.contentSecondLi1') }}</li>
								
							</ul>
                            <div
                  class="btn button-style mt-md-5 mt-4"
                  id="applyUse"
                  @click="openDialog"
                >
                  {{ $t("jem.application") }}</div>

						</div>

					</div>
					<div class="col-lg-5 left-img-w3ls">
						<img src="@/assets/images/b6.png" alt="" class="img-fluid">
					</div>
				</div>
			</div>
		</section>
		<section class="bottom-count py-5" id="stats">
			<div class="container py-xl-5 py-lg-3">
				<div class="row">
					<div class="col-lg-5 left-img-w3ls">
						<img src="@/assets/images/b2.png" alt="" class="img-fluid">
					</div>

					<div class="col-lg-7 right-img-w3ls pl-lg-4 mt-lg-2 mt-4">
						<div class="bott-w3ls mr-xl-5">
							<h3 class="title-w3 text-bl mb-3 font-weight-bold">{{ $t('ifm.contentTitle3') }}</h3>

							<ul class="w3l-right-book mt-4">
								<li>{{ $t('ifm.contentThirdli1') }}</li>
								<li>{{ $t('ifm.contentThirdli2') }}</li>
							</ul>
                            <div
                  class="btn button-style mt-md-5 mt-4"
                  id="applyUse"
                  @click="openDialog"
                >
                  {{ $t("jem.application") }}</div>
						</div>

					</div>

				</div>
			</div>
		</section>
        <LogoComponent></LogoComponent>
      </div>
      <SubmitForm ref="applyDialog"></SubmitForm>
      
    </basic-container>
  </template>
  
  <script>
  import LogoComponent from "@/components/commonComponents/logoComponent";
  import SubmitForm from "@/components/submitForm/submitPersonalForm";

  export default {
    components: { SubmitForm,LogoComponent },
    name: "",
    data() {
      return {};
    },
    created() {},
    methods: {
        openDialog() {
      this.$refs.applyDialog.openDialog()
    },
    },
  };
  </script>
  
  <style lang="scss" scoped></style>